import { TopThreatsWebComponent } from './component/TopThreatsWebComponent';
import { WEB_COMPONENT_WIDGET_TOP_THREATS } from '../webcomponents.constants';

export { TopThreatsWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_TOP_THREATS, TopThreatsWebComponent);
